export default "__VITE_ASSET__BqMrEmbd__"